import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';
import classNames from 'classnames';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import PropTypes from 'prop-types';
import { WithAudienceAssociationsRepository } from './repository';

export const IMAReachWarning = ({ i18n, isInherit }) => (
  <div className={classNames('alert', 'alert-info', 'form-group', 'ima-reach-alert')}>
    <div className="alert-image" />
    <div className="alert-info-inline">
      {isInherit ? i18n.getString('IMA_Reach_Representation_Inherit_Warning_Message') :
       i18n.getString('IMA_Reach_Representation_Warning_Message')}
      {isInherit ? (
        <a className="HelpTopic" query="help:app50080" href="#!">
          &nbsp;
          {i18n.getString('Learn more')}
        </a>) : null}
    </div>
  </div>);

IMAReachWarning.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  isInherit: PropTypes.bool,
};

IMAReachWarning.defaultProps = {
  isInherit: false,
};

export const getIMAAssocaitonInfo = ({ audienceAssociations, adGroupId }) => {
  const adGroupAudienceAssociations = _.chain(audienceAssociations)
    .result('value', [])
    .filter(association => association.Level === 'AdGroup')
    .value();

  const campaignAudienceAssociations = _.chain(audienceAssociations)
    .result('value', [])
    .filter(association => association.Level === 'Campaign')
    .value();

  // ad group level location targeting Or campaign level location targeting
  // and there are IMA audience associations in current ad group or campaign
  if ((adGroupId
    && adGroupAudienceAssociations
    && adGroupAudienceAssociations.length > 0) ||
    (!adGroupId && campaignAudienceAssociations && campaignAudienceAssociations.length > 0)) {
    return {
      adGroupAudienceAssociations,
      campaignAudienceAssociations,
      isIMAReachWarningShow: true,
    };
  }
  // Else: no IMA audience target, or no IMA audience is in the parent level,
  // which will not influenced by current settings.
  return {
    adGroupAudienceAssociations,
    campaignAudienceAssociations,
    isIMAReachWarningShow: false,
  };
};

// condition to show IMAReachWarning, when there is IMA audience association
const IMAReachWarningShowWithConditions = ({
  audienceAssociations, adGroupId, i18n,
}) => {
  if (audienceAssociations.dataNotReady) {
    return null;
  }
  const {
    isIMAReachWarningShow,
    adGroupAudienceAssociations,
  } = getIMAAssocaitonInfo({
    audienceAssociations,
    adGroupId,
  });

  if (isIMAReachWarningShow) {
    return (<IMAReachWarning i18n={i18n} />);
  } else if (!adGroupId &&
    adGroupAudienceAssociations &&
    adGroupAudienceAssociations.length > 0) {
    return (<IMAReachWarning isInherit i18n={i18n} />);
  }
  return null;
};

IMAReachWarningShowWithConditions.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  audienceAssociations: PropTypes.shape({}).isRequired,
  adGroupId: PropTypes.number,
};


IMAReachWarningShowWithConditions.defaultProps = {
  adGroupId: null,
};

const IMAReachWarningComponent = props => (
  <WithAudienceAssociationsRepository
    WrappedComponent={IMAReachWarningShowWithConditions}
    {...props}
  />);

export const showIMAReachWarning = ({
  cid,
  aid,
  containerDOM,
  campaignId,
  i18n,
  adGroupId = null,
  audienceAssociations = null, // for creation workflow, audience assocaition is from outside.
}) => {
  ReactDOM.render(
    <ScopeContext.Provider value={{
      scope: {
        values: {
          cid, aid, adGroupId, campaignId,
          },
        },
    }}
    >
      {audienceAssociations ?
      (<IMAReachWarningShowWithConditions
        audienceAssociations={audienceAssociations}
        adGroupId={adGroupId}
        i18n={i18n}
      />) :
      (<IMAReachWarningComponent campaignId={campaignId} adGroupId={adGroupId} i18n={i18n} cid={cid} aid={aid} />)
      }
    </ScopeContext.Provider>,
    containerDOM
  );
};

